import { createColumnHelper } from "@tanstack/table-core";
import type { MeterReadingModel } from "../../mobx/core/meter/model.meter-reading";

export { getMeterReadingTableColumnAccessor } from "./column-accessors";
export { METER_READING_COLUMN_CONFIGS } from "./column-config";
export type { MeterReadingTableColumnAccessor } from "./column-accessors";
export type {
  MeterReadingColumnConfig,
  MeterReadingTableAccessorKey,
  MeterReadingValueCellPayload,
} from "./column-config";

import { meterReadingMatchesGlobalFilter } from "./utils/global-filter";
export { meterReadingMatchesGlobalFilter };
export const meterReadingColumnHelper = createColumnHelper<MeterReadingModel>();
